import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-012fbd21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-main-settings-page" }
const _hoisted_2 = { class: "project-main-settings-page__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "project-main-settings-page__title" }, "Основная информация", -1))
const _hoisted_4 = {
  key: 1,
  class: "project-main-settings-page__content"
}
const _hoisted_5 = { class: "project-main-settings-page__head" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "project-main-settings-page__cropper"
}
const _hoisted_8 = { class: "project-modal__head-controls" }
const _hoisted_9 = { class: "project-main-settings-page__switches" }
const _hoisted_10 = { class: "project-main-settings-page__switch" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project-main-settings-page__switch-title" }, "Активный проект", -1))
const _hoisted_12 = { class: "project-main-settings-page__switch-paragparh" }
const _hoisted_13 = { class: "project-main-settings-page__switch" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "project-main-settings-page__switch-title" }, "Разрешить импорт с weeek"),
  /*#__PURE__*/_createElementVNode("div", { class: "project-main-settings-page__switch-paragparh" }, " Дополнительная опция при создании тикетов, позволяющаяя импртировать задачи с weeek.ru ")
], -1))

import ShortProfile from '@/api/Main/dataSource/api/users/profile/i-service/models/ShortProfile';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmInput,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirToggle,
} from 'tir-components';
import { computed, nextTick, onMounted, ref, watch } from 'vue';

import ApiService from '@/api';
import { PhotoIcon } from 'tir-style-system/icons/outline';
import { useRouter } from 'vue-router';

import { TirPmCropper, TirCropperVarsModel, CropSelectionModel } from 'tir-pm-cropper';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { FotoRequest, ProjectDataModel } from './models';
import { BaseProjectResponse } from '@/components/task-forms/components/task-copying-modal/models';
import { EnumProjectType } from './enums';
import { ProjectNoSaveModal, ProjectSettingsSkeleton } from './components';

export default /*#__PURE__*/_defineComponent({
  __name: 'project-main-settings-page',
  props: {
  /**Доступ к weeek */
  isAccessWeeek: { type: Boolean },
},
  emits: ["uppdateProject", "updateAllowImportWeeek"],
  setup(__props, { emit }) {

const props = __props;

TirCropperVarsModel.setVars(new TirCropperVarsModel());

const api = new ApiService();

/**Параметры */




/**
 * Переменная для поиска по юзерам в модалке
 */
const searchStringForUser = ref('');

const copiedEditData = ref<BaseProjectResponse>();
/**url новой фотки */
const urlNewImage = ref();
/**Разрешение на редактирование */
const permissionEdit = ref(false);
/**Изначальные данные проекта */
const initialProjectData = ref<ProjectDataModel>();
/**Статус проекта */
const projectStatus = ref<EnumProjectType>();
/**Загрузка */
const isLoading = ref<boolean>();
/**Видимость окна подтверждения выхода */
const isVisibleModal = ref(false);
/**Загрузка проекта */
const isLoadingProject = ref(false);
/**состояние импорта weeek */
/**Сохранено фото */
const isSavePhoto = ref<boolean>();
const weeekState = ref();
const currentPhotoProject = ref(null);
const currentPhotoProjectSetting = ref<CropSelectionModel>();
const sendFileInput = ref(null);
const isOpenCropper = ref(false);
const croppedNewPhoto = ref();

const editProjectName = ref<string>();
const src = ref();
/**Данные проекта */
const currentProjectData = ref<ProjectDataModel>(
  new ProjectDataModel({
    Name: '',
  }),
);
/**Статус проекта */
const projectStatusBoolean = computed<boolean>({
  get: () => currentProjectData.value.Status === 0,
  set: (state: boolean) => {
    currentProjectData.value.Status = state ? 0 : 1;
  },
});
/**Произошли ли изменения в настройках проекта */
const isProjectSettingsChanged = computed(() => {
  const current = JSON.stringify(currentProjectData.value);
  const initial = JSON.stringify(initialProjectData.value);

  return current == initial;
});
/**Надпись в зависимости от статуса проекта */
const projectStatusLabel = computed(() => {
  return !currentProjectData.value.Status
    ? 'Проект активен: можно создавать тикеты, пользователи будут видеть уведомления об изменениях'
    : 'Проект помещен в Архив: пользователи не видят задач, все уведомления по задачам для всех выключены';
});
/**
 * Сохранить загруженную фотку
 */
const onSaveFile = (e) => {
  if (e.target.files.length) {
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = function () {
      isOpenCropper.value = true;
      currentPhotoProject.value = reader.result as string;
      urlNewImage.value = reader.result as string;
      // croppedNewPhoto.value = reader.result as string;
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
};
const onCroppedPhoto = (croppedPhoto) => {
  croppedNewPhoto.value = croppedPhoto;
  currentProjectData.value.Image = new FotoRequest({
    ...currentProjectData.value.Image,
    Image: currentPhotoProject.value,
  });
};
const onCloseCropper = () => {
  permissionEdit.value = true;
  isOpenCropper.value = false;
};
const chosePhoto = () => {
  sendFileInput.value.click();
};
/**Текущее название проекта */
let currentEditProjectName = null;

/**Проверка на изменение в инпуте  */
const isInputModified = () => {
  nextTick(() => {
    permissionEdit.value = editProjectName.value !== currentEditProjectName;
  });
};

const onCropPhoto = (cropData: CropSelectionModel) => {
  sendFileInput.value.value = null;
  currentPhotoProjectSetting.value = cropData;
  currentProjectData.value.Image = new FotoRequest({
    Height: cropData.Height,
    Width: cropData.Width,
    Left: cropData.X,
    Top: cropData.Y,
  });
};

// Переменная для списка пользователей, чтобы назначить из него админом или участником для селекта
const UserList = ref<Array<ShortProfile>>([]);

const selectedAdminUsers = ref<Array<ShortProfile>>([]);
const copiComparedUserList = ref<Array<ShortProfile>>([]);
const computedNameCompareFoto = (admin: ShortProfile) => {
  return admin.FirstName[0].toUpperCase() + admin.LastName[0].toUpperCase();
};

const loadProjects = async () => {
  let { Items } = await api.Main.PerformersListService.getOwnedUsersAsync({
    StatusList: [1],
    Search: '',
    Page: {
      Skip: 0,
      Take: 1000,
    },
  });
  UserList.value = Items;
  copiComparedUserList.value = UserList.value;
};

// Функция для фильтрации юзеров
const filteredUser = (selectedUserName?: ShortProfile & string) => {
  copiComparedUserList.value = UserList.value;
  copiComparedUserList.value = copiComparedUserList.value.filter(
    (x) => !selectedAdminUsers.value.find((y) => y.UserId == x.UserId),
  );
  if (typeof selectedUserName == 'string' && selectedUserName.length) {
    copiComparedUserList.value = copiComparedUserList.value.filter((x) => {
      let compairedString = x.FirstName + ' ' + x.MiddleName + ' ' + x.MiddleName;
      return compairedString.includes(selectedUserName);
    });
  }
};

const computedAdminListForRender = (adminList: Array<ShortProfile>) => {
  let newAdminList;
  if (adminList.length > 5) {
    newAdminList = adminList.slice(0, 5);
    return newAdminList;
  } else {
    return adminList;
  }
};

// Функция для выбора юзера для селекта администраторы
const setAdminToProject = (selectedUser: ShortProfile) => {
  selectedAdminUsers.value.push(selectedUser);
  filteredUser();
  searchStringForUser.value = '';
};
/**Подтверждение выхода из окна */
const confirmLeave = () => {
  currentProjectData.value.Name = initialProjectData.value.Name;
  currentProjectData.value.Image = initialProjectData.value.Image;
  currentProjectData.value.WeeekEnable = initialProjectData.value.WeeekEnable;
  currentProjectData.value.Status = initialProjectData.value.Status;
};

// Функция для удаления юзера для селекта администраторы
const removeAdminForProject = (removedAdmin: ShortProfile) => {
  selectedAdminUsers.value = selectedAdminUsers.value.filter(
    (x) => x.UserId !== removedAdmin.UserId,
  );
  filteredUser();
};
/**Изменение видимости окна подтверждения  выхода */
const toggleVisibleModal = (state: boolean) => {
  isVisibleModal.value = state;
};
// Сохранить модалку редактирования
const saveModalEditEmployee = async () => {
  isLoading.value = true;

  if (!copiedEditData.value.Id) {
    isLoading.value = false;
    return;
  }

  try {
    // Emit если флаг weeek изменился
    if (initialProjectData.value.WeeekEnable !== currentProjectData.value.WeeekEnable) {
      emit('updateAllowImportWeeek', weeekState.value);
    }

    const payload: any = {
      Id: copiedEditData.value.Id,
      Name: currentProjectData.value.Name,
      AdminsIds: editProjectName.value.AdminsIds,
      Status: currentProjectData.value.Status,
      Types: [],
    };

    const currentImage = currentProjectData.value.Image?.Image;
    const initialImage = initialProjectData.value.Image?.Image;

    const imageChanged = currentImage && currentImage !== initialImage;

    if (imageChanged) {
      payload.Image = new FotoRequest({
        Height: currentProjectData.value.Image.Height,
        Width: currentProjectData.value.Image.Width,
        Left: currentProjectData.value.Image.Left,
        Top: currentProjectData.value.Image.Top,
        Image: currentImage,
      });
    }

    await api.Main.ProjectBaseService.updateAsync(payload);

    emit('uppdateProject');

    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: 'Успешное редактирование',
        type: 'success',
        group: 'general',
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );

    isOpenCropper.value = false;

    // Обновляем initialProjectData
    initialProjectData.value = new ProjectDataModel({
      Image: currentProjectData.value.Image,
      Name: currentProjectData.value.Name,
      Status: currentProjectData.value.Status,
      WeeekEnable: currentProjectData.value.WeeekEnable,
    });
  } catch (err: unknown) {
    console.log(err, 'error new');

    const errorMessage =
      typeof err === 'object' && err && 'ErrorMessage' in err
        ? (err as any).ErrorMessage
        : 'Произошла ошибка при сохранении';

    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: errorMessage,
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  } finally {
    permissionEdit.value = false;
    isLoading.value = false;
  }
};

/**Обновление состояние weeek */
const changeWeeekState = (state: boolean) => {
  weeekState.value = state;
};

const route = useRouter();

onMounted(async () => {
  isLoadingProject.value = true;
  try {
    copiedEditData.value = await api.Main.ProjectBaseService.getIdAsync({
      ProjectId: Number(route.currentRoute.value.params.projectId),
    });

    croppedNewPhoto.value = copiedEditData.value?.ImageUrl;
    projectStatus.value = copiedEditData.value.Status;
    weeekState.value = copiedEditData.value.WeeekEnable;
    editProjectName.value = copiedEditData.value.Name;
    currentEditProjectName = copiedEditData.value.Name;
    await loadProjects();
  } catch {}
  currentProjectData.value = new ProjectDataModel({
    Image: new FotoRequest({
      Image: croppedNewPhoto.value,
    }),
    Name: copiedEditData.value.Name,
    Status: projectStatus.value,
    WeeekEnable: weeekState.value,
  });
  initialProjectData.value = new ProjectDataModel({
    Image: new FotoRequest({
      Image: croppedNewPhoto.value,
    }),
    Name: copiedEditData.value.Name,
    Status: projectStatus.value,
    WeeekEnable: weeekState.value,
  });
  isLoadingProject.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(TirPmButton), {
          isLoading: isLoading.value,
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          size: _unref(TirPmButtonSizeEnum).Small,
          isDisabled: isProjectSettingsChanged.value || isLoadingProject.value || isOpenCropper.value,
          onClick: saveModalEditEmployee
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Сохранить ")
          ]),
          _: 1
        }, 8, ["isLoading", "variant", "size", "isDisabled"])
      ]),
      (isLoadingProject.value)
        ? (_openBlock(), _createBlock(_unref(ProjectSettingsSkeleton), { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (!isOpenCropper.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = 
            () => {
              !isOpenCropper.value && _unref(CurrentUser).Roles.includes(_unref(UserRoleEnum).Owner)
                ? chosePhoto()
                : null;
            }
          )
                  }, [
                    _createVNode(_unref(TirPmIconView), {
                      size: 128,
                      isRounded: "",
                      isBordered: !isOpenCropper.value && !currentPhotoProject.value
                    }, {
                      mainSlot: _withCtx(() => [
                        _createVNode(_unref(PhotoIcon), { style: {"width":"5rem","height":"5rem"} }),
                        (croppedNewPhoto.value)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: croppedNewPhoto.value,
                              alt: ""
                            }, null, 8, _hoisted_6))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["isBordered"])
                  ]))
                : _createCommentVNode("", true),
              (isOpenCropper.value && currentPhotoProject.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_unref(TirPmCropper), {
                      modelValue: currentPhotoProject.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPhotoProject).value = $event)),
                      src: currentPhotoProject.value,
                      onCrop: onCropPhoto,
                      onSave: onCloseCropper,
                      onChoseOtherPhoto: chosePhoto,
                      onOnCroppedPhoto: onCroppedPhoto
                    }, null, 8, ["modelValue", "src"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("input", {
                  type: "file",
                  ref_key: "sendFileInput",
                  ref: sendFileInput,
                  onChange: onSaveFile,
                  accept: "image/png, image/gif, image/jpeg, .jpg",
                  style: {"display":"none"}
                }, null, 544),
                (
              croppedNewPhoto.value && !isOpenCropper.value && _unref(CurrentUser).Roles.includes(_unref(UserRoleEnum).Owner)
            )
                  ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                      key: 0,
                      onClick: chosePhoto,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      variant: _unref(TirPmButtonVariantEnum).SecondaryState
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Редактировать фото ")
                      ]),
                      _: 1
                    }, 8, ["size", "variant"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_unref(TirPmInput), {
              modelValue: currentProjectData.value.Name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentProjectData.value.Name) = $event)),
              onInput: isInputModified,
              isDisabled: !_unref(CurrentUser).Roles.includes(_unref(UserRoleEnum).Owner),
              placeholder: "Лучший проект на свете :)",
              label: "Название проекта",
              "is-with-hint": false
            }, null, 8, ["modelValue", "isDisabled"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(TirToggle), {
                  modelValue: projectStatusBoolean.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((projectStatusBoolean).value = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", null, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, _toDisplayString(projectStatusLabel.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(TirToggle), {
                  modelValue: currentProjectData.value.WeeekEnable,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((currentProjectData.value.WeeekEnable) = $event)),
                    changeWeeekState
                  ]
                }, null, 8, ["modelValue"]),
                _hoisted_14
              ])
            ])
          ]))
    ]),
    _createVNode(_unref(ProjectNoSaveModal), {
      visible: isVisibleModal.value,
      isProjectSettingsChanged: isProjectSettingsChanged.value,
      onToggleVisibleModal: toggleVisibleModal,
      onConfirmLeave: confirmLeave
    }, null, 8, ["visible", "isProjectSettingsChanged"])
  ], 64))
}
}

})